import { render } from "./TrainingPage.vue?vue&type=template&id=47e1e7f4&scoped=true&lang=pug"
import script from "./TrainingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingPage.vue?vue&type=script&setup=true&lang=js"

import "./TrainingPage.vue?vue&type=style&index=0&id=47e1e7f4&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e1e7f4"]])

export default __exports__